import React, { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { product1, product2, product3, product4 } from '../../../assets/images';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Products = () => {

  const { t, i18n } = useTranslation();
  const [list, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.tanura.az/tanura/dashboard.php`,
        { withCredentials: false }
      );
  
      // Tüm veriyi al ve sadece ilk 8 tanesini seç
      const limitedData = response.data.data.slice(0, 4);
  
      console.log(limitedData);
      setItems(limitedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  

  if (isLoading) {
    return <p className="text-center text-[white]">Loading...</p>;
  }

  return (
      <div className="max-w-containerSm md:max-w-container mx-auto mt-[40px] md:mt-[88px]">
      <p className="text-[22px] md:text-[28px] font-semibold text-center mb-10">{t("Set məhsullarımız")}</p>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 px-4">
        {list.map((product) => (
          <a key={product.id} href={`/product-detail/${product.id}`}>
            <ProductCard
            id={product.id}
              name={product.name}
              gender={product.gender}
              volume={product.volume}
              price={product.price} 
              image={product.image} 
            />
          </a>
        ))}
      </div>
     <div className='text-center mt-6'>
     <a className='text-[#223077]' href='/products'>{t("Hamısını gör")} <i className="fa fa-arrow-right ml-1"></i></a>
     
     </div>
    </div>
  );
};

export default Products;
